export const LIST_PRODUCT = "LIST_PRODUCT";
export const TYPE_FORM_CREATE = "CREATE";
export const TYPE_FORM_UPDATE = "UPDATE";
export const DEFAULT_SKIP = 0;
export const DEFAULT_LIMIT = 20;
export const CURRENT_LANG_STORED = "lang";
export const ACCESS_TOKEN_STORE = "access_token";
export const RESET_MAIL_STORED = "reset_email";
export const BILLING_INFO_FORM = "billing";
export const SHIPPING_INFO_FORM = "shipping";
export const PROFILE_FORM = "profile";
export const BILLING_ADDRESS_FORM = "billing_address";
export const SHIPPING_ADDRESS_FORM = "shipping_address";
export const FIELD_USER_NAME = "name";
export const FIELD_USER_FULL_NAME = "full_name";
export const ROLE_LIGHT_PLAN = "light plan";
export const ROLE_VENDOR = "vendor";
export const ROLE_FULL_SUPPORT_PLAN = "full support plan";
export const FIRST_TAB = 1;
export const SECOND_TAB = 2;
export const THIRD_TAB = 3;
export const FOURTH_TAB = 4;
export const FIFTH_TAB = 5;
export const LANG_ENGLISH = "en";
export const LANG_JAPANESE = "ja";
export const LANG_PHILIPPINES = "tl";
export const LANG_VIETNAMESE = "vi";
export const LANG_CHINESE = "zh";
export const DEFAULT_IMAGE = "images/image-default.png";
export const TYPE_IMAGE_PNG = "image/png";
export const TYPE_IMAGE_JPEG = "image/jpeg";
export const TYPE_IMAGE_JPG = "image/jpg";
export const REMEMBER_LOGIN_STORED = "REMEMBER_LOGIN_STORED";
export const ACCESS_TOKEN_STORED = "ACCESS_TOKEN_STORED";
export const USER_ROLES = {
  ADMIN: "administrator",
  VENDOR: "vendor",
};
